module.exports = __webpack_public_path__ + "static/media/eina04-semibold.6cf42680.woff";